"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var listMissingProperties_1 = __importDefault(require("./helper/listMissingProperties"));
function everyItemOfArrayShouldHave(requiredProperties) {
    // return the vue validator function
    return function (array) { return scanArray(array, requiredProperties); };
}
function scanArray(array, requiredProperties) {
    var missingPropertiesInEachItem = array.map(function (item) {
        return listMissingProperties_1.default(item, { requiredProperties: requiredProperties });
    });
    var hasAnyInvalidItemInArray = missingPropertiesInEachItem.some(function (item) {
        // if any item of this array has a length greater than zero it means
        // this property has an item with at least one property missing
        return item.length;
    });
    if (!hasAnyInvalidItemInArray) {
        return true;
    }
    else {
        console.error('Array (', array, ') has invalid items, see table below for missing itens:');
        console.table(missingPropertiesInEachItem);
        return false;
    }
}
exports.default = everyItemOfArrayShouldHave;
//# sourceMappingURL=everyItemOfArrayShouldHave.js.map